export default "__VITE_ASSET__BwcvSU9k__"